import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enPhrases from "./locales/en/en.json";
import trPhrases from "./locales/tr/tr.json";

// the translations
const resources = {
  en: enPhrases,
  tr: trPhrases,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "tr",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
